// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-dialog.v-dialog--active::-webkit-scrollbar{width:8px}.v-dialog.v-dialog--active::-webkit-scrollbar-track{background:transparent}.v-dialog.v-dialog--active::-webkit-scrollbar-thumb{background-color:rgba(0,0,0,.41176);border-radius:15px;border:1px solid #a5a5a5}.share-file-label{color:rgba(0,0,0,.87);font-size:.95rem;line-height:1.5}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
